import { render, staticRenderFns } from "./RadioOption.vue?vue&type=template&id=e962d54a&scoped=true&"
import script from "./RadioOption.vue?vue&type=script&lang=js&"
export * from "./RadioOption.vue?vue&type=script&lang=js&"
import style0 from "./RadioOption.vue?vue&type=style&index=0&id=e962d54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e962d54a",
  null
  
)

export default component.exports